import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DatePicker, Button, Input, Select, message, Icon, Switch, Tooltip, AutoComplete } from 'antd';
import HighSearchInput from '../../common/HighSearchInput';
import API_URL from '../../../common/url';
import { generateOptions } from '../../shared/selectFn';
import { saveParams } from '../../../actions/noticeActions';
import { Default, ContractNature, JdeApplyStatus } from './constants';
import moment from 'moment';
import $ from '../../../common/AjaxRequest';

const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const DefaultOption = generateOptions(Default);
const ContractNatureOption = generateOptions(ContractNature);
const JdeApplyStatusOption = Object.keys(JdeApplyStatus).map(d => (
    <Option key={String(d)} text={JdeApplyStatus[d]}>
        <Tooltip placement="right" title={JdeApplyStatus[d]}>
            <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{JdeApplyStatus[d]}</span>
        </Tooltip>
    </Option>
));

class Filter extends Component {
    state = {
        reRender: true,
        searchParams: {},
        expand: false,
        JdeAutoFlag:0,
        busOppNumOptions: [],
        evaluateCodeOptions: [],
    }

    componentDidMount() {
        
        const { params } = this.props;
        const { searchParams } = this.state;
        if (params.jdeApplyCode) {
            searchParams.jdeApplyCode = params.jdeApplyCode;
        }
        if (this.props.match && this.props.match.params.jdeApplyCode) {
            searchParams.jdeApplyCode = this.props.match.params.jdeApplyCode;
        }
        this.setState({ searchParams }, () => {
            this.search();
        });
        this.loadJDEAutoSet();
    }
    
    componentWillUnmount() {
        const { saveParams } = this.props;
        saveParams({ 
            jdeApplyCode: undefined,
            investigationId: undefined,
            investigationName: undefined,
            investigationSiteId: undefined,
            investigationSiteName: undefined,
            investigationSiteCode: undefined,
            webCondition: undefined,
            target: undefined,
        });
    }

    // 校验value是否存在，且是options中的一项
    validateValueInOptions = (value, name, list) => {
        if (value) {
            const isExist = list.some(item => item.value == value);
            if (!isExist) {
                message.warning(`请选择正确的${name}`);
                return true;
            }
        }
        return false;
    }

    search = () => {
        const {
            searchParams,
            searchParams: {
                sponsorId,
                customerCompanyId,
                investigationId,
                createUserId,
                distributeStartTime,
                distributeEndTime,
                finStartAgreeDate,
                finEndAgreeDate,
            },
            invOptions,
            userOptions,
            sponsorOptions,
            companyOptions,
        } = this.state;
        if (this.validateValueInOptions(investigationId, '项目简称', invOptions)) {
            return;
        }
        if (this.validateValueInOptions(sponsorId, '申办方', sponsorOptions)) {
            return;
        }
        if (this.validateValueInOptions(customerCompanyId, '客户全名', companyOptions)) {
            return;
        }
        if (this.validateValueInOptions(createUserId, '申请人姓名', userOptions)) {
            return;
        }
        if ((distributeStartTime && !distributeEndTime) || (!distributeStartTime && distributeEndTime)) {
            message.warning('请选择发号开始/结束日期');
            return;
        }
        if ((finStartAgreeDate && !finEndAgreeDate) || (!finStartAgreeDate && finEndAgreeDate)) {
            message.warning('请选择FIN审核合同金额通过开始/结束日期');
            return;
        }
        this.props.search(searchParams);
        this.props.saveParams({ 
            jdeApplyCode: undefined,
            investigationId: undefined,
            investigationName: undefined,
            investigationSiteId: undefined,
            investigationSiteName: undefined,
            investigationSiteCode: undefined,
            webCondition: undefined,
            target: undefined,
        });
    }

    reset = () => {
        const { saveParams } = this.props;
        saveParams({ jdeApplyCode: '' });
        this.setState({
            reRender: false,
            searchParams: {},
        }, () => {
            this.setState({ reRender: true }, () => {
                this.search();
            });
        })
    }

    export = () => {
        this.props.export();
    }

    handleKeyPress = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        if (field === 'lineOfBusinessIds') {
            searchParams[field] = value ? value.join(',') : '';
            searchParams.secondLineName = undefined;
        } else {
            searchParams[field] = value;
        }
        this.setState({ searchParams });
    }

    /**
     * 业务机会编号、临床评估单号 请求候选列表
     */
    fetchAutoCompleteOptions = (value, field) => {
        const config = {
            busOppNum: { url: API_URL.contract.queryBusOppNumList, param: 'busOppNum', optionsName: 'busOppNumOptions' },
            evaluateCode: { url: API_URL.contract.queryEvaluateCodeList, param: 'evaluateCode', optionsName: 'evaluateCodeOptions' },
        }[field];
        const options = {
            method: 'POST',
            url: config.url,
            data: { [config.param]: value || '' },
            dataType: 'json',
            doneResult: res => {
                this.setState({ [config.optionsName]: res.list || [] });
            },
        };
        $.sendRequest(options);
    }

    /**
     * 业务机会编号、临床评估单号 键入检索，防抖请求候选列表
     */
    handleAutoCompleteChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
        clearTimeout(this[`${field}SearchTimer`]);
        this[`${field}SearchTimer`] = setTimeout(() => {
            this.fetchAutoCompleteOptions(value, field);
        }, 300);
    }

    /**
     * 业务机会编号、临床评估单号 搜索框选中（获得焦点）时即查询候选数据，参考项目简称搜索框
     */
    handleAutoCompleteFocus = (field) => {
        const optionsName = {
            busOppNum: 'busOppNumOptions',
            evaluateCode: 'evaluateCodeOptions',
        }[field];
        // 已有候选数据时不重复请求
        if ((this.state[optionsName] || []).length) {
            return;
        }
        this.fetchAutoCompleteOptions('', field);
    }

    /**
     * 点击选中下拉返回的候选内容
     */
    handleAutoCompleteSelect = (value, field) => {
        this[`${field}Selected`] = true;
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    /**
     * 搜索输入框未获得焦点（失焦）且本次不是点击选中下拉候选内容，清空搜索输入框内文本
     */
    handleAutoCompleteBlur = (field) => {
        if (!this[`${field}Selected`]) {
            const { searchParams } = this.state;
            searchParams[field] = undefined;
            this.setState({ searchParams });
        }
        this[`${field}Selected`] = false;
    }

    updateApplyJdeCode = () => {
        this.props.updateApplyJdeCode({}, 'add');
    }

    handleStartDate = (dates, dateString, field) => {
        const { searchParams } = this.state;
        if (field == 'distribute') {
            searchParams.distributeStartTime = dateString;
        } else {
            searchParams.finStartAgreeDate = dateString;
        }
        this.setState({ searchParams });
    }

    handleEndDate = (date, dateString, field) => {
        const { searchParams } = this.state;
        if (field == 'distribute') {
            searchParams.distributeEndTime = dateString;
            !dateString && (searchParams.distributeStartTime = dateString);
        } else {
            searchParams.finEndAgreeDate = dateString;
            !dateString && (searchParams.finStartAgreeDate = dateString);
        }
        this.setState({ searchParams });
    }

    handleHighSearchInputChange = (id, options, idName, optionsName) => {
        const { searchParams } = this.state;
        searchParams[idName] = id;
        this.setState({
            searchParams,
            [optionsName]: options,
        });
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    loadJDEAutoSet=()=>{
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeAutoSetting,
            data: {},
            dataType: 'json',
            doneResult: (data) => {
                this.setState({ JdeAutoFlag: data.auto });
            }
        }
        $.sendRequest(options)
    }

    toggle = (checked) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.updateJdeAutoSetting,
            data: {
                auto: checked ? 1 : 0,
            },
            dataType: 'json',
            doneResult: (data) => {
                if(checked){
                    message.success("开启提前上岗JDE自动发号");
                }else{
                    message.success("关闭提前上岗JDE自动发号");  
                }
                this.setState({ JdeAutoFlag: checked ? 1 : 0 });
            }
        }
        $.sendRequest(options);
    }

    render() {
        const { curRole, invState } = sessionStorage;
        const { businessList, signingUnitList, belongingToUnitList, canAdd } = this.props;
        const { searchParams, reRender, expand } = this.state;
        const {
            jdeApplyCode,
            jdeApplyIsInvestigationExists,
            isClinicalProject,
            contractOrLetterIsSign,
            natureOfContract,
            customerProjectCode,
            investigationJdeCode,
            customerJdeCode,
            jdeApplyStatus,
            distributeStartTime,
            distributeEndTime,
            finStartAgreeDate,
            finEndAgreeDate,
            lineOfBusinessIds,
            secondLineName,
            belongingToUnit,
            signingUnit,
            isRealitySettle,
            isMsaSpecialContractReduce,
            isMsaSpecialDiscountCustom,
            isDiscountTermValidity,
            havePaperContract,
            busOppNum,
            evaluateCode,
        } = searchParams;
        const newDistributeStartTime = distributeStartTime ? moment(distributeStartTime) : null;
        const newDistributeEndTime = distributeEndTime ? moment(distributeEndTime) : null;
        const newFinStartAgreeDate = finStartAgreeDate ? moment(finStartAgreeDate) : null;
        const newFinEndAgreeDate = finEndAgreeDate ? moment(finEndAgreeDate) : null;
        const maxHeight = expand ? 280 : 40;
        const isTotal = invState == 1;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            const arr = (lineOfBusinessIds || '').split(',');
            if (arr.some(j => j == i.typeConfigureId)) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={String(i.typeConfigureId)}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const signingUnitOptions = signingUnitList.map(i => <Option key={String(i.unitOfSigningId)}>{i.unitOfSigningName}</Option>);
        const belongingToUnitOptions = belongingToUnitList.map(i => <Option key={String(i.unitOfBelongingId)}>{i.unitOfBelongingName}</Option>);
        return (
            <div style={{ marginBottom: 16 }}>
                <div className="search-bar bar2 expand" style={{ maxHeight: maxHeight }}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">申请编号</label>
                        <Input placeholder="请输入" value={jdeApplyCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'jdeApplyCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">系统中是否有此项目</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={jdeApplyIsInvestigationExists}
                            onChange={value => this.handleSelectChange(value, 'jdeApplyIsInvestigationExists')}
                        >
                            { DefaultOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目简称</label>
                        {
                            reRender &&
                            <HighSearchInput
                                keyword='investigationName'
                                style={{ width: 160 }}
                                placeholder="输入名称检索"
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryInvestigationByName}
                                config={{ id: 'investigationId', name: 'investigationName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'investigationId', 'invOptions')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">此项目是否为临床项目</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 100}}
                            value={isClinicalProject}
                            onChange={value => this.handleSelectChange(value, 'isClinicalProject')}
                        >
                            { DefaultOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">合同或函证是否签署</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 100}}
                            value={contractOrLetterIsSign}
                            onChange={value => this.handleSelectChange(value, 'contractOrLetterIsSign')}
                        >
                            { DefaultOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">合同性质</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={natureOfContract}
                            onChange={value => this.handleSelectChange(value, 'natureOfContract')}
                        >
                            { ContractNatureOption }
                        </Select>
                    </div>
                    {
                        !isTotal &&
                        <div className="search-item">
                            <label className="ui-label">业务线</label>
                            <Select
                                mode="multiple"
                                allowClear={true}
                                filterOption={false}
                                placeholder="请选择"
                                style={{width: 120}}
                                value={lineOfBusinessIds ? lineOfBusinessIds.split(',') : []}
                                className="multiple-stage"
                                onChange={value => this.handleSelectChange(value, 'lineOfBusinessIds')}
                            >
                                {businessOption}
                            </Select>
                        </div>
                    }
                    {
                        !isTotal &&
                        <div className="search-item">
                            <label className="ui-label">执行业务线二级分类</label>
                            <Select
                                allowClear={true}
                                filterOption={false}
                                placeholder="请选择"
                                style={{width: 120}}
                                value={secondLineName}
                                disabled={!lineOfBusinessIds}
                                onChange={value => this.handleSelectChange(value, 'secondLineName')}
                            >
                                {secondLineOption}
                            </Select>
                        </div>
                    }
                    <div className="search-item">
                        <label className="ui-label">合同签署单位</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 140}}
                            value={signingUnit}
                            onChange={value => this.handleSelectChange(value, 'signingUnit')}
                        >
                            {signingUnitOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">收入归属单位</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 100}}
                            value={belongingToUnit}
                            onChange={value => this.handleSelectChange(value, 'belongingToUnit')}
                        >
                            {belongingToUnitOptions}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">申办方</label>
                        {
                            reRender &&
                            <HighSearchInput
                                keyword='customerCompanyName'
                                style={{ width: 162 }}
                                placeholder="输入名称检索"
                                params={{ limit: 20, natureName: '申办方' }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'sponsorId', 'sponsorOptions')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">项目编号</label>
                        <Input placeholder="请输入" onKeyPress={this.handleKeyPress} value={customerProjectCode} onChange={e => this.handleInputChange(e, 'customerProjectCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户全名</label>
                        {
                            reRender &&
                            <HighSearchInput
                                keyword='customerCompanyName'
                                style={{ width: 160 }}
                                placeholder="输入名称检索"
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryCustomerCompanyByName}
                                config={{ id: 'customerCompanyId', name: 'customerCompanyName' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'customerCompanyId', 'companyOptions')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户JDE号</label>
                        <Input placeholder="请输入" value={customerJdeCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'customerJdeCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">申请状态</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 160}}
                            value={jdeApplyStatus}
                            optionLabelProp="text"
                            onChange={value => this.handleSelectChange(value, 'jdeApplyStatus')}
                        >
                            { JdeApplyStatusOption }
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">申请人姓名</label>
                        {
                            reRender &&
                            <HighSearchInput
                                name="user"
                                keyword='keyword'
                                style={{ width: 140 }}
                                placeholder="输入姓名/工号检索"
                                params={{ limit: 20 }}
                                url={API_URL.investigation.queryUserByKey}
                                config={{ id: 'userId', name: 'userCompellation', code: 'employeeCode' }}
                                onChange={(id, options) => this.handleHighSearchInputChange(id, options, 'createUserId', 'userOptions')}
                            />
                        }
                    </div>
                    <div className="search-item">
                        <label className="ui-label">JDE项目号</label>
                        <Input placeholder="请输入" value={investigationJdeCode} onKeyPress={this.handleKeyPress} onChange={e => this.handleInputChange(e, 'investigationJdeCode')}/>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">发号时间</label>
                        <DatePicker
                            format={dateFormat}
                            value={newDistributeStartTime}
                            allowClear={true}
                            placeholder="开始日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleStartDate(date, dateString, 'distribute')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">至</label>
                        <DatePicker
                            className="end"
                            format={dateFormat}
                            value={newDistributeEndTime}
                            allowClear={true}
                            placeholder="结束日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleEndDate(date, dateString, 'distribute')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">FIN审核合同金额通过时间</label>
                        <DatePicker
                            format={dateFormat}
                            value={newFinStartAgreeDate}
                            allowClear={true}
                            placeholder="开始日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleStartDate(date, dateString, 'fin')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">至</label>
                        <DatePicker
                            format={dateFormat}
                            value={newFinEndAgreeDate}
                            allowClear={true}
                            placeholder="结束日期"
                            style={{ width: 100 }}
                            onChange={(date, dateString) => this.handleEndDate(date, dateString, 'fin')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">是否据实结算</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={isRealitySettle}
                            onChange={value => this.handleSelectChange(value, 'isRealitySettle')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">MSA特殊优惠是否从合同额中扣减</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={isMsaSpecialContractReduce}
                            onChange={value => this.handleSelectChange(value, 'isMsaSpecialContractReduce')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">客户是否MSA特殊优惠客户</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={isMsaSpecialDiscountCustom}
                            onChange={value => this.handleSelectChange(value, 'isMsaSpecialDiscountCustom')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">是否在优惠有效期内</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={isDiscountTermValidity}
                            onChange={value => this.handleSelectChange(value, 'isDiscountTermValidity')}
                        >
                            <Option value={-1}>为空</Option>
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">是否拥有纸质合同</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 80}}
                            value={havePaperContract}
                            onChange={value => this.handleSelectChange(value, 'havePaperContract')}
                        >
                            <Option value={1}>是</Option>
                            <Option value={0}>否</Option>
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">业务机会编号</label>
                        <AutoComplete
                            dataSource={this.state.busOppNumOptions}
                            style={{ width: 140 }}
                            value={busOppNum}
                            placeholder="输入检索"
                            filterOption={false}
                            onKeyPress={this.handleKeyPress}
                            onFocus={() => this.handleAutoCompleteFocus('busOppNum')}
                            onChange={value => this.handleAutoCompleteChange(value, 'busOppNum')}
                            onSelect={value => this.handleAutoCompleteSelect(value, 'busOppNum')}
                            onBlur={() => this.handleAutoCompleteBlur('busOppNum')}
                        />
                    </div>
                    <div className="search-item">
                        <label className="ui-label">临床评估单号</label>
                        <AutoComplete
                            dataSource={this.state.evaluateCodeOptions}
                            style={{ width: 140 }}
                            value={evaluateCode}
                            placeholder="输入检索"
                            filterOption={false}
                            onKeyPress={this.handleKeyPress}
                            onFocus={() => this.handleAutoCompleteFocus('evaluateCode')}
                            onChange={value => this.handleAutoCompleteChange(value, 'evaluateCode')}
                            onSelect={value => this.handleAutoCompleteSelect(value, 'evaluateCode')}
                            onBlur={() => this.handleAutoCompleteBlur('evaluateCode')}
                        />
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        
                        {curRole == 'FIN'&&
                        <div className="item" style={{ textAlign: 'center',marginRight:10 }}>
                            <label className="ui-label" style={{ marginRight: 20 }}>提前上岗JDE自动发号</label>
                            <span className="">
                            <Switch checkedChildren="开" unCheckedChildren="关" onChange={this.toggle} checked={this.state.JdeAutoFlag == 1} />
                            </span>
                        </div>
                        }
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        <Button type="primary" onClick={this.export}>导出</Button>
                        { canAdd && <Button type="primary" onClick={this.updateApplyJdeCode}>添加</Button> }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        params: state.noticeState.params,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Filter);


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/Filter.js